module.exports = __webpack_public_path__ + "img/1586.dcac0057.gif";